import { t } from 'i18next'

export const valueOrEmpty = (value?: string): string => {
  if (!value) {
    return t('common.empty')
  }
  return value
}

export const truncate = (value: string, maxLength: number): string => {
  if (value.length > maxLength) {
    return `${value.slice(0, maxLength)}…`
  }
  return value
}
